// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"Login_loginForm__369_g","errorText":"Login_errorText__12vYO","right":"Login_right__NozME"};